import type React from 'react';

import { ResponseList } from './ResponseList';

// Todo: Remove Wrapper: https://change.atlassian.net/browse/CHANGE-86589
export const ResponseListWrapper: React.FC = () => {
	return <ResponseList />;
};
